import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import useCategories from '../../hooks/useCategories';
import { HiOutlineBars3BottomRight } from 'react-icons/hi2';
import { useAuthInfo } from '../../contexts/authProvider/AuthProvider';
import { FaUserCheck, FaUserTimes } from 'react-icons/fa';
import useCurrentUserRole from '../../hooks/useCurrentUserRole';

const Header = () => {
    const { user } = useAuthInfo();
    const { isGeneralUser } = useCurrentUserRole();
    const { pathname } = useLocation();
    const { categories } = useCategories();
    const navLinks = <>
        {
            categories?.map(({ _id, categoryId, categoryName, }) => <li key={_id}>
                <Link to={`/categories/${categoryId}`}>{categoryName}</Link>
            </li>)
        }
    </>

    return (
        <div className="navbar bg-base-200 flex justify-between">
            <div>
                <div className="dropdown">
                    <label tabIndex={0} className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex={0} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52 font-semibold">
                        {navLinks}
                    </ul>
                </div>
                <Link to='/' className="btn btn-ghost normal-case text-xl">SSF News</Link>
            </div>
            <div className="hidden lg:flex">
                <ul className="menu menu-horizontal px-1 font-semibold">
                    {navLinks}
                </ul>
            </div>
            <div>
                {user && !isGeneralUser && <Link to='/dashboard' className=''>
                    <button className='btn'>Dashboard</button>
                </Link>}
                {pathname.includes('dashboard') && <label htmlFor="my-drawer-2" className="btn drawer-button lg:hidden"><HiOutlineBars3BottomRight size={20} /></label>}
                {
                    user ? <Link to='/user-profile' className='btn'><FaUserCheck size={20} /></Link> : <Link to='/sign-in' className='btn'><FaUserTimes size={20} /></Link>
                }
            </div>
        </div>
    );
};

export default Header;